import React from "react";
import Campaigns from "../modules/Campaigns/Campaigns";

export default function CampaignsPage() {
  return <Campaigns />;
}
